import { StringFormatter } from '../string.utils'

export type ToFullNameOptions = {
  mode: 'firstname-lastname' | 'lastname-firstname'
}

export const toFullName = (
  firstName?: string,
  lastName?: string,
  { options }: { options?: ToFullNameOptions } = {}
) => {
  const result: string[] = []
  if (options?.mode === 'lastname-firstname') {
    if (lastName) result.push(lastName.toUpperCase())
    if (firstName) result.push(StringFormatter.capitalize(firstName))
  } else {
    if (firstName) result.push(StringFormatter.capitalize(firstName))
    if (lastName) result.push(lastName.toUpperCase())
  }
  return result.join(' ')
}
